module.exports = __webpack_public_path__ + "assets/valance-wave-scallop-short-selected.2cbb077a.svg";